import gql from 'graphql-tag';
import { ComponentQuery, ComponentQueryResult } from './ComponentQuery';
import { ISelectOption } from 'react-ocean-forms-bootstrap';
import { ComponentFormValues, KomponentenTypEnum } from '../../components/ParamComponents';
import { ColumnSortInfo } from '../../components/DataTable/PCDataTable';
import { GraphQLUtil } from '../GraphQLUtil';
import { KomponenteFilter, Maybe, Dimension } from '../../generated/types';
import { DocumentNode } from 'graphql';

class DimensionQueryImpl extends ComponentQuery {

  /**
   * 
   * @param role 
   * @param filter 
   * @returns 
   */
  public getFilter(role: string, filter: ComponentFormValues): KomponenteFilter {
    const queryFilter: KomponenteFilter = this.getGeneralFilter(role, filter);

    if(filter.kind === KomponentenTypEnum.Dimension) {
      if(filter?.symbol) queryFilter.symbolContains = filter.symbol;
    }

    return queryFilter;
  }
  
  /**
   * 
   * @param codeList 
   * @returns 
   */
  public getFilterDuplicates(codeList: string[]): KomponenteFilter {
    return this.getGeneralDuplicateFilter(codeList);
  }

  /**
   * creates query for Dimension for search query with sorting 
   * @param sortBy 
   * @returns 
   */
  public getComponentList(sortBy?: ColumnSortInfo[]): ComponentQueryResult {

    const sort = GraphQLUtil.transformSortByList(sortBy);

    const query = gql`
    query DIMENSION_FILTER_PAGE($number: Int!, $size: Int!, $filter: KomponenteFilter, $sort: [Sort]) {
      dimensionen(
        page: {number: $number, size: $size},
        filter: $filter,
        sort: $sort
      ) {
        data {
          id
          code
          name
          status
          createdDate
          lastModifiedDate
          symbol
        },
        page  { number, size, totalElements, totalPages}
      }
    }
    `;

    return {query, sort};
  }

  /**
   * creates query for dimensionen used by AsyncSelect component
   * @returns 
   */
  public getPagedComponents(): any {
    return gql`
      query DIMENSION_PAGE($number: Int!, $size: Int!, $name: String, $status: [KomponenteStatus]){
        dimensionen (
          page: {number: $number, size: $size},
          filter: { nameContains: $name, status: $status }
        ){
          data {
            id
            code
            symbol
            status
            name
          },
          page  { number, size, totalElements, totalPages}
        }
      }
    `;
  }


  /**
   * get component by id for details view (read,update,delete)
   *           
   */
  public getComponent(): DocumentNode {
    return gql`
      query DIMENSION($id: ID!) {
        dimension (id: $id) {
          id
          code
          name
          symbol
          anforderung {
            anmerkung
            email
            zweckOderQuelle
          }
          status
        }
      }
    `;
  }

  public getDropdownLabel(obj: Maybe<Dimension>): string {
    if (obj === null) return '';
    return `${obj.symbol} - ${obj.name}`;
  }

  public getSelectOption(obj: Maybe<Dimension>): ISelectOption | undefined {
    if (obj === null) return undefined;
    return {
      label: this.getDropdownLabel(obj),
      value: JSON.stringify(obj)
    }
  }
}

export const DimensionQuery = new DimensionQueryImpl();
